<forge-card class="info-grid--container no-padding" [ngClass]="{'combined-view-grid': combinedViewTable}">

    <!-- placeholder for testing, to be implemented later -->
    <!-- <div style="padding: var(--forge-spacing-medium);">
        <forge-text-field show-clear density="small" (forge-text-field-clear)="clearPromptFilter()">
            <input #searchFilter type="text" tabindex="0" placeholder="Search" [(ngModel)]="promptFilter"
                (keydown)="searchKeyDown($event)" aria-label="search">
        </forge-text-field>
    </div> -->

    <igx-grid igxPreventDocumentScroll #grid [isLoading]="fetching() || isAdding() || grouping()" [id]="providerId"
        [data]="data | async" [primaryKey]="'Id'" [igxGridState]="options" [rowSelection]="selectionMode()"
        emptyFilteredGridMessage="No records found. They may be hidden by grid filters."
        (activeNodeChange)="activeNodeChange($event)" [hideRowSelectors]="hideRowSelectors"
        (columnInit)="onColumnInit($event)" (cellEditEnter)="onCellEditEnter($event)"
        (cellEditExit)="endCellEdit($event)" (keyup)="onKeyUp($event)" (gridKeydown)="handleGridKeydown($event)"
        (rowSelectionChanging)="onRowSelect($event)" [cellSelection]="cellSelectionMode" (keydown)="onKeyDown($event)"
        [allowFiltering]="!noFilter()" [filterMode]="'excelStyleFilter'" [moving]="true" [pagingMode]="mode"
        [filterStrategy]="filterStrategy" [sortStrategy]="sortStrategy" [clipboardOptions]="clipboardOptions"
        [uniqueColumnValuesStrategy]="columnValuesStrategy" (doubleClick)="editRow($event)"
        (contextMenu)="onContextMenu($event)" height="100%" (columnPinned)="columnPinned($event)"
        (selected)="onCellSelect($event)" [ngClass]="{'alternate-grid-lines': alternateGridLines()}"
        (gridScroll)="onScroll($event)" style="--ig-size: var(--ig-size-small)" [rowClasses]="rowClasses">
        <ng-template igxRowSelector let-rowContext>
            <div class="row-selector">
                <igx-checkbox [readonly]="true" [checked]="rowContext.selected" (click)="rowCheckSelect()"
                    [disabled]="!isSelectionAllowed(rowContext.rowID)"
                    [aria-label]="rowContext.selected ? 'Deselect row ' + rowContext.index + 1 : 'Select row ' + rowContext.index + 1">
                </igx-checkbox>
            </div>
        </ng-template>
        @if (showIdTemplate()) {
        <igx-column field="Id" header="Id" [hidden]="true" [disableHiding]="true" [disablePinning]="true"
            [filterable]="false"></igx-column>
        }
        <igx-column field="_selected" header="Selected" [hidden]="true" [exportable]="true" [disableHiding]="true" [disablePinning]="true"></igx-column>
        @for (column of columns(); track trackByFn($index, column)) {
        <igx-column [field]="column.Name" [groupable]="isGroupedGrid" [width]="getColumnWidth(column.Name)"
            [header]="column.Label" [dataType]="column.$computedDataType" editable="true" [resizable]="true"
            [sortable]="allowSort() && !column.IsIcon" [filterable]="filterable(column)"
            [hidden]="columnHidden(column.Name) || column.AlwaysHidden" [disableHiding]="column.AlwaysHidden"
            [disablePinning]="!pinnable(column)" [cellClasses]="cellClasses" [filteringIgnoreCase]="false">
            <!-- this attribute added to address new bug in igx v21 that uses this on string field to build filter tree-->

            <ng-template igxHeader let-column>
                <column-move-selector [grid]="grid" [column]="column" [columns]="columns()"
                    title="{{column.header}}"></column-move-selector>
            </ng-template>
            <ng-template igxCell let-cell="cell" let-val>
                @switch (column.$renderInfo) {
                @case ('boolean') {
                <div [attr.cell-identifier]="column.$cellId" style="width: 100%; text-align: center;"
                    (click)="editCheckbox(cell)">
                    @if (parseBooleanValue(val)) {
                    <forge-icon name="check_box" class="grid-icon" aria-label="checked"></forge-icon>
                    }
                    @if (!parseBooleanValue(val)) {
                    <forge-icon name="check_box_outline_blank" class="grid-icon" aria-label="not checked">
                    </forge-icon>
                    }
                </div>
                }
                @case ('icon') {
                <div [attr.cell-identifier]="column.$cellId"
                    [ngClass]="{'cell-action': cellActionClass(column, cell), 'cell-action-disabled': isDisabled(cell)}"
                    (click)="doAction(cell)" role="button">
                    <forge-icon [name]="getIcon(cell)" [hidden]="useIconSpan(cell) || isHidden(cell)">
                        <forge-tooltip>{{val}}</forge-tooltip>
                    </forge-icon>
                    <span class="tt-icon {{getIcon(cell)}}" [hidden]="!useIconSpan(cell) || isHidden(cell)"></span>
                </div>
                }
                @case ('currency') {
                <span [attr.cell-identifier]="column.$cellId" class="igx-grid-cell-value">{{val |
                    gridCurrency: column}}</span>
                }
                @case ('number') {
                <span [attr.cell-identifier]="column.$cellId" class="igx-grid-cell-value">{{val |
                    gridNumber: column:false}}</span>
                }
                @case ('percent') {
                <span [attr.cell-identifier]="column.$cellId" class="igx-grid-cell-value">{{val |
                    gridNumber: column:true}}</span>
                }
                @case ('date') {
                <span [attr.cell-identifier]="column.$cellId" class="igx-grid-cell-value">{{val |
                    date:'MM/dd/yyyy'}}</span>
                }
                @case ('dateTime') {
                <span [attr.cell-identifier]="column.$cellId" class="igx-grid-cell-value">{{val | date:
                    column.$dateTimeFormat}}</span>
                }
                @case ('time') {
                <span [attr.cell-identifier]="column.$cellId" class="igx-grid-cell-value">{{val | date:
                    column.$timeFormat}}</span>
                }
                @case ('time24') {
                <span [attr.cell-identifier]="column.$cellId" class="igx-grid-cell-value">{{val | date:
                    column.$time24Format}}</span>
                }
                @case ('lookup') {
                @if (lookupLoading(column)) {
                <forge-skeleton class="grid-lookup-loading"></forge-skeleton>
                }
                @if (!lookupLoading(column)) {
                <span [attr.cell-identifier]="column.$cellId" class="igx-grid-cell-value" [title]="val">{{val}}</span>
                }
                }
                @case ('actionLookup') {
                @if (lookupLoading(column)) {
                <forge-skeleton class="grid-lookup-loading"></forge-skeleton>
                }
                @if (!lookupLoading(column)) {
                <div [attr.cell-identifier]="column.$cellId"
                    [attr.role]="cellActionClass(column, cell) ? 'link' : undefined"
                    [ngClass]="{'cell-action': cellActionClass(column, cell), 'cell-action-disabled': isDisabled(cell)}"
                    (click)="doAction(cell)">
                    <span class="igx-grid-cell-value" [title]="val">{{val}}</span>
                </div>
                }
                }
                @case ('actionFormatted') {
                <div [attr.cell-identifier]="column.$cellId"
                    [ngClass]="{'cell-action': cellActionClass(column, cell), 'cell-action-disabled': isDisabled(cell)}"
                    (click)="doAction(cell)" role="link">
                    @switch (column.DataType) {
                    @case ('currency') {
                    <span class="igx-grid-cell-value">{{ val | gridCurrency: column }}</span>
                    }
                    @case ('number') {
                    <span class="igx-grid-cell-value">{{val | gridNumber: column:false}}</span>
                    }
                    @case ('nonDelineatedNumber') {
                    <span class="igx-grid-cell-value">{{val | gridNumber: column:false}}</span>
                    }
                    @case ('percent') {
                    <span class="igx-grid-cell-value">{{val | gridNumber: column:true}}</span>
                    }
                    @case ('date') {
                    <span class="igx-grid-cell-value">{{val | date:'MM/dd/yyyy'}}</span>
                    }
                    @case ('dateTime') {
                    <span class="igx-grid-cell-value">{{val | date: dateTimeFormat}}</span>
                    }
                    @case ('time') {
                    <span class="igx-grid-cell-value">{{val | date: timeFormat}}</span>
                    }
                    @case ('time24') {
                    <span class="igx-grid-cell-value">{{val | date: timeFormat24}}</span>
                    }
                    @default {
                    <span class="igx-grid-cell-value" [title]="val">{{val}}</span>
                    }
                    }
                </div>
                }
                @case ('actionDefault') {
                <div [attr.cell-identifier]="column.$cellId"
                    [attr.role]="cellActionClass(column, cell) ? 'link' : undefined"
                    [ngClass]="{'cell-action': cellActionClass(column, cell), 'cell-action-disabled': isDisabled(cell)}"
                    (click)="doAction(cell)" role="link">
                    <span class="igx-grid-cell-value" [title]="val">{{val}}</span>
                </div>
                }
                @default {
                <span [attr.cell-identifier]="column.$cellId" class="igx-grid-cell-value" [title]="val">{{ val }}</span>
                }
                }
            </ng-template>
            <ng-template igxCellEditor let-cell="cell" let-value #cellEditTemplate>
                <div #cellEditInput fxFill [attr.cell-identifier]="column.$cellId">
                    <form>
                        @if (!cellEditInPopup() && !cellEditTransition()) {
                        <metadata-input ngModelGroup="cellEditGrp_{{cell.column.field}}" fxFill
                            [field]="cell.column.field" id="{{cell.column.field}}_gridInput"
                            [metadata]="cellEditMetadata" [metadataModel]="cellEditModel()"
                            [parent]="cellEditModelParent" [datacontroller]="datacontroller()"
                            [parentGridProvider]="providerId" [forCellEdit]="true" [dense]="true"
                            (keydown)="cellEditKeyDown($event)">
                        </metadata-input>
                        }
                        <forge-popover #cellEditInlinePopover placement="bottom-end" position-strategy="fixed"
                            shift="false" (forge-popover-beforetoggle)="onPopoverBeforeToggle($event)">
                            <cell-edit-overlay (doLeaveCellEdit)="leaveCellEdit($event)"
                                [inlineEdit]="true"></cell-edit-overlay>
                        </forge-popover>
                        @if (cellEditInPopup()) {
                        <forge-popover #cellEditPopupPopover placement="bottom right" position-strategy="fixed"
                            shift="false" [offset]="{ mainAxis: -5, crossAxis: -1 }"
                            (forge-popover-beforetoggle)="onPopoverBeforeToggle($event)">
                            <forge-scaffold>
                                <div slot="body"
                                    style="width: 400px; padding: var(--forge-spacing-small); padding-bottom: 0;"
                                    (click)="$event.stopPropagation()">
                                    @if (!cellEditTransition()) {
                                    <metadata-input #cellEditPopupInput ngModelGroup="cellEditGrp_{{cell.column.field}}"
                                        fxFill [field]="cell.column.field" id="{{cell.column.field}}_gridInput"
                                        [metadata]="cellEditMetadata" [metadataModel]="cellEditModel()"
                                        [parent]="cellEditModelParent" [datacontroller]="datacontroller()"
                                        [parentGridProvider]="providerId" [forCellEdit]="true" [dense]="true"
                                        (keydown)="cellEditKeyDown($event)">
                                    </metadata-input>
                                    }
                                    <cell-edit-overlay (doLeaveCellEdit)="leaveCellEdit($event)"
                                        [inlineEdit]="false"></cell-edit-overlay>
                                </div>
                            </forge-scaffold>
                        </forge-popover>
                        }
                    </form>
                </div>
            </ng-template>
        </igx-column>
        }

        <ng-template igxExcelStyleHeaderIcon>
            <forge-icon class="grid-filter-icon" name="filter_alt"></forge-icon>
        </ng-template>

        <igx-grid-excel-style-filtering [minHeight]="filterHeight()" [maxHeight]="filterHeight()">
            <igx-excel-style-column-operations>
                <igx-excel-style-header [showPinning]="true" [showHiding]="true"></igx-excel-style-header>
            </igx-excel-style-column-operations>
            <igx-excel-style-filter-operations>
                <igx-excel-style-clear-filters (click)="clearCustomFilter()"></igx-excel-style-clear-filters>
                <igx-excel-style-conditional-filter></igx-excel-style-conditional-filter>
                @if (showCustomFilter) {
                <grid-filter [grid]="grid" [columns]="columns()" [viewMetadata]="viewMetadata()"></grid-filter>
                }
                @if (showExcelStyleSearch) {
                <igx-excel-style-search style="max-height:280px;"></igx-excel-style-search>
                }
            </igx-excel-style-filter-operations>
        </igx-grid-excel-style-filtering>

        <igx-action-strip #actionStrip>
            @if (!cellEditing) {
            <row-actions [actionStrip]="actionStrip" [providerId]="providerId" [cellEdit]="isGridCellEdit()"
                [useRepository]="useRepository()" [refreshAction]="refreshAction()"
                (refreshActionChange)="refreshAction.set($event)" [disableViewAction]="disableViewAction()"
                [datacontroller]="datacontroller()"
                (repositoryFunction)="doRepositoryFunction($event.command, $event.row)" [multipleEdit]="multipleEdit()"
                [viewMetadata]="viewMetadata()">
            </row-actions>
            }
        </igx-action-strip>
        <igx-grid-toolbar #toolbar>
            <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    @if (showTitle) {
                    <h2 class="forge-typography--heading2">
                        {{viewMetadata().Title}}
                    </h2>
                    }
                    @if (showH1Title) {
                    <h1 class="forge-typography--heading2">
                        {{h1Title}}
                    </h1>
                    }
                    @if (showFiltered) {
                    <forge-badge theme="info-secondary" class="tt-margin--left">Filtered</forge-badge>
                    }
                    @if (hiddenSelections) {
                    <forge-badge theme="info-secondary" class="tt-margin--left">Selected Rows Hidden</forge-badge>
                    }
                </div>
                <span fxFlex="auto"></span>
                @if (AllowMultipleDelete) {
                <div fxLayout="row" fxLayoutAlign="center center">
                    <forge-button (click)="deleteMultipleRows()" [disabled]="isMassDeleting()">
                        <forge-icon name="delete" style="color: var(--forge-theme-primary);"></forge-icon>
                        <span style="color: var(--forge-theme-primary);">Delete selected</span>
                    </forge-button>
                </div>
                }
                <span fxFlex="auto"></span>
                <div fxLayout="row" fxLayoutAlign="end center" style="position: sticky; right: 16px;">
                    <forge-icon-button (click)="toggleTableOptionsOpen()" aria-label="Toggle table options"
                        class="grid-icon-button">
                        <forge-tooltip placement="bottom">
                            <span>{{ tableOptionsOpen() ? 'Hide' : 'Show' }} table options</span>
                        </forge-tooltip>
                        <forge-open-icon [open]="!tableOptionsOpen()" orientation="horizontal"></forge-open-icon>
                        <forge-focus-indicator circular inward></forge-focus-indicator>
                    </forge-icon-button>

                    <forge-expansion-panel orientation="horizontal" [open]="tableOptionsOpen()"
                        aria-label="Table options" role="region">
                        @if (showToolbar() && grid.toolbar) {
                        <div fxLayout="row" fxLayoutAlign="end center" class="table-options toolbar-icon-container">
                            @if (showGridSearch) {
                            <grid-search [grid]="grid" [columns]="columns()"></grid-search>
                            }
                            <forge-icon-button [hidden]="!showFiltered" class="button grid-icon-button"
                                (click)="clearFilter()" aria-label="clear filters">
                                <forge-tooltip placement="bottom">Clear filters</forge-tooltip>
                                <forge-icon name="filter_remove"></forge-icon>
                                <forge-focus-indicator circular inward></forge-focus-indicator>
                            </forge-icon-button>
                            <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
                            <forge-icon-button (click)="openColumnVisibility()" class="button grid-icon-button"
                                aria-label="Column visibility" telemetry="Load-Column-visibility"
                                [variant]="toolbarButtonVariant('visibility')">
                                <forge-icon name="eye"></forge-icon>
                                <forge-tooltip placement="bottom">Column visibility</forge-tooltip>
                                <forge-focus-indicator circular inward></forge-focus-indicator>
                            </forge-icon-button>
                            <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
                            <forge-icon-button (click)="openColumnPinning()" class="button grid-icon-button"
                                aria-label="Column pinning" telemetry="Load-Column-pinning"
                                [variant]="toolbarButtonVariant('pinning')">
                                <forge-icon name="pin"></forge-icon>
                                <forge-tooltip placement="bottom">Column pinning</forge-tooltip>
                                <forge-focus-indicator circular inward></forge-focus-indicator>
                            </forge-icon-button>
                            <forge-icon-button [igxToggleAction]="exportDropdown"
                                [igxDropDownItemNavigation]="exportDropdown" class="button grid-icon-button"
                                aria-label="Export" telemetry="Load-Export">
                                <forge-icon name="file_upload"></forge-icon>
                                <forge-tooltip placement="bottom">Export</forge-tooltip>
                                <forge-focus-indicator circular inward></forge-focus-indicator>
                            </forge-icon-button>
                            <igx-drop-down #exportDropdown>
                                <div class="dropdown-item-container">
                                    <igx-drop-down-item (click)="exportData('excel')" igxRipple value="excel"
                                        role="option" index="0">
                                        <span>Export to Excel</span>
                                    </igx-drop-down-item>
                                    @if (allowCsvExport) {
                                    <igx-drop-down-item (click)="exportData('csv')" igxRipple value="csv" role="option"
                                        index="1">
                                        <span>Export to CSV</span>
                                    </igx-drop-down-item>
                                    }
                                </div>
                            </igx-drop-down>
                            @if (allowShowRecent()) {
                            <forge-icon-button (click)="toggleHistory(!recentLoaded())" class="button grid-icon-button"
                                telemetry="Load-Recent" [variant]="toolbarButtonVariant('history')"
                                aria-label="Recent grid history">
                                <forge-icon name="history"></forge-icon>
                                <forge-tooltip placement="bottom">Recent history</forge-tooltip>
                                <forge-focus-indicator circular inward></forge-focus-indicator>
                            </forge-icon-button>
                            }
                            <forge-icon-button [hidden]="!enableLayout" class="button grid-icon-button"
                                [igxToggleAction]="gridLayoutDropdown" [igxDropDownItemNavigation]="gridLayoutDropdown"
                                aria-label="Layout options">
                                <forge-tooltip placement="bottom">Layout options</forge-tooltip>
                                <forge-icon name="grid_view"></forge-icon>
                                <forge-focus-indicator circular inward></forge-focus-indicator>
                            </forge-icon-button>
                            <igx-drop-down #gridLayoutDropdown>
                                <div class="dropdown-item-container">
                                    <igx-drop-down-item (click)="layoutAction($event)" igxRipple
                                        *igxFor="let item of layoutOptions; index as index;" [value]="item.value"
                                        role="option" [index]="index">
                                        <span>{{ item.label }}</span>
                                    </igx-drop-down-item>
                                </div>
                            </igx-drop-down>
                        </div>
                        }
                    </forge-expansion-panel>

                    @if (canAdd()) {
                    <forge-button variant="raised" aria-label="Add"
                        [disabled]="isViewOnly() || isAdding() || disableGridAdd()" (click)="addItem(true)" tabindex="0"
                        dense>
                        <forge-icon slot="start" name="add"></forge-icon>
                        Add
                    </forge-button>
                    }

                    @if (commandMenu) {
                    <command-menu [commands]="commands" icon="more_vert" always-show-icon="true" fxLayout="row"
                        fxLayoutAlign="space-between center" position="target-right bottom" telemetry="Menu-Table">
                    </command-menu>
                    }

                    @if (commandBar) {
                    <command-bar [commands]="commands" fxLayout="row" fxLayoutAlign="space-between center"
                        telemetry="Menu-TableMenuBar">
                    </command-bar>
                    }
                </div>
            </div>
        </igx-grid-toolbar>

        <igx-paginator>
            <igx-paginator-content fxLayoutAlign="end">
                <div>Total Records: {{totalCount()}}</div>
            </igx-paginator-content>
        </igx-paginator>
    </igx-grid>

    <ng-container #contextMenuContainer></ng-container>
</forge-card>